module.exports = __webpack_public_path__ + "img/public/SiteIcons/transmissionIcon.svg?aa36cb57";